const updates = [
  { date: '2026-07-31', tag: '新片上线', text: '《速度与激情12》高清版正式上线，同步更新中英双语字幕，超清画质畅享飙车盛宴。' },
  { date: '2026-07-30', tag: '热播跟新', text: '《庆余年》第三季第15集更新，范闲朝堂斗智再升级，每日更新不卡顿持续追剧中。' },
  { date: '2026-07-30', tag: '系统升级', text: '播放器引擎升级至 V5.2，优化高清解码效率，流畅观看超清画质无广告体验再提升。' },
  { date: '2026-07-29', tag: '片库更新', text: '经典港片专区新增 50 部修复版影片，周星驰、成龙经典作品高清重现。' },
  { date: '2026-07-28', tag: '新剧上线', text: '《三体：黑暗森林》独家上线，刘慈欣科幻巨制改编，全景声杜比音效加持。' },
  { date: '2026-07-27', tag: '综艺更新', text: '《向往的生活》第八季最新期上线，高清播放在线不缓冲，田园治愈综艺回归。' },
  { date: '2026-07-26', tag: '动漫上线', text: '《雾山五行》第二季全 12 集一次性上线，国产水墨风动画巅峰之作。' },
  { date: '2026-07-25', tag: '专题上线', text: '「暑期档必看」专题页面上线，整理 100 部高分电影电视剧免费在线观看。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            最新动态
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            实时快讯 · 精彩不间断
          </h2>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-300" />
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 md:gap-7 pl-10 md:pl-14">
                <div className="absolute left-[13px] md:left-[21px] top-2 w-2.5 h-2.5 rounded-full bg-accent-500 ring-4 ring-background-100" />
                <div className="flex-shrink-0 text-xs text-foreground-400 whitespace-nowrap pt-0.5">
                  {item.date}
                </div>
                <div className="flex-1 min-w-0">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-secondary-100 text-secondary-700 mb-1.5 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <p className="text-foreground-700 text-sm leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}